export default "__VITE_ASSET__yLgUyn3p__"